module.exports = __webpack_public_path__ + "static/media/envelope-open-text.d76e8af8.svg";